// Angular core modules
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// App components
import { SettingsComponent } from './settings/settings.component';

export const routes: Routes = [
    {
        path: '',
        component: SettingsComponent
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(routes)
    ],
    declarations: [],
    exports: [
        RouterModule
    ]
})
export class SettingsRoutingModule { }
